import React, { useState } from 'react';
import axios from 'axios';
import Modal from './common/Modal';
import SmsVerifyStep from './SmsVerifyStep';
import { toast } from './common/Toast';
import * as usersApi from '../api/users';
import { formatPhoneInput, isValidPhone } from '../utils/phone';

interface PhoneChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentPhone: string;
  onSuccess: () => void;
}

const PhoneChangeModal: React.FC<PhoneChangeModalProps> = ({
  isOpen,
  onClose,
  currentPhone,
  onSuccess,
}) => {
  const [newPhone, setNewPhone] = useState('');
  const [smsVerified, setSmsVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setNewPhone('');
    setSmsVerified(false);
    onClose();
  };

  const handleSubmit = async () => {
    if (!smsVerified) {
      toast.error('SMS 인증을 완료해주세요');
      return;
    }
    setLoading(true);
    try {
      await usersApi.changeMyPhone(newPhone);
      toast.success('휴대폰 번호가 변경되었습니다');
      onSuccess();
      handleClose();
    } catch (err) {
      const msg = axios.isAxiosError(err)
        ? (err.response?.data as { error?: string } | undefined)?.error
        : undefined;
      toast.error(msg || '번호 변경에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="휴대폰 번호 변경"
      onConfirm={handleSubmit}
      confirmText={loading ? '변경 중...' : '변경'}
    >
      <p style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
        현재: <strong>{currentPhone}</strong>
      </p>
      <div className="form-group">
        <label>새 휴대폰 번호</label>
        <input
          type="tel"
          value={newPhone}
          onChange={(e) => setNewPhone(formatPhoneInput(e.target.value))}
          placeholder="010-0000-0000"
          maxLength={13}
          disabled={smsVerified}
        />
      </div>
      {isValidPhone(newPhone) && (
        <SmsVerifyStep
          phone={newPhone}
          purpose="phone_change"
          onVerified={() => setSmsVerified(true)}
          disabled={smsVerified}
        />
      )}
    </Modal>
  );
};

export default PhoneChangeModal;
